import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ServiceUsageCardCmp_ResolvableServiceUsage_Fragment = graphql(`
  fragment ServiceUsageCardCmp_ResolvableServiceUsage_Fragment on ResolvableServiceUsage {
    _id
    __typename
    specialService {
      ...ServiceUsageCardCmp_ResolvableServiceBaseInterface_Fragment
    }
    contentOriginId
    index
    quantity {
      ...ResolvableQuantityCmp_ResolvableQuantity_Fragment
    }
    serviceId
    serviceOriginId
    serviceUsageOrigin {
      missionTypeId
      serviceUsageId
    }
    settings {
      showAmountsInQuotation {
        ...ResolvableBooleanCmp_ResolvableBoolean_Fragment
      }
      showCostsInQuotation {
        ...ResolvableBooleanCmp_ResolvableBoolean_Fragment
      }
      showMaterialsInQuotation {
        ...ResolvableBooleanCmp_ResolvableBoolean_Fragment
      }
      showQuantitiesInQuotation {
        ...ResolvableBooleanCmp_ResolvableBoolean_Fragment
      }
    }
  }
`);

export type ServiceUsageCardCmp_ResolvableServiceUsage = ResultOf<
  typeof ServiceUsageCardCmp_ResolvableServiceUsage_Fragment
>;
